<template>
    <v-container fluid>
        <v-card flat class="px-2">
            <v-card-title class="escalation-matrix d-flex justify-space-between">
              <span>Matrix List</span>
              <span>
                <v-btn
                  dense
                  color="accent"
                  elevation="0"
                  small
                  :to="{name: 'createTicketMatrix'}"
                >
                  Create Matrix
                </v-btn>
              </span>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="matrixData"
                :items-per-page="10"
                item-key="name"
              ></v-data-table>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import CONSTANTS from '@/utils/constants'
export default {
  name: 'escalation-matrix',
  data () {
    return {
      headers: [
        { text: 'queryRelatedTo / Department', align: 'start', sortable: false, value: 'queryRelatedTo.name' },
        { text: 'queryType / Catergory ', value: 'queryType.name' },
        { text: 'Escalation', value: 'level.name' },
        { text: 'Email Id', value: 'emailId' },
        { text: 'Zone', value: 'zone.name' }
      ],
      matrixData: []
    }
  },
  created () {
    this.getMatrixDataList()
  },
  methods: {
    getMatrixDataList: async function () {
      try {
        let res = await http.get(`${CONSTANTS.API_URL}/api/sbTicketing/getMatrixList`)
        if (res.status === 200) {
          this.matrixData = res.data
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    }
  }
}
</script>
